import { EDIT_TOKEN_ROLE, EDIT_TOKEN_STORAGE_KEYS } from '@messenger/consts'

/**
 * Whether this tab's editor session was opened through a designer edit
 * token. Designers get messenger-level editing but a designer-shaped
 * shell: no storefront step navigation, and the access label reads
 * Designer.
 */
export const isDesignerTokenSession = (): boolean =>
  sessionStorage.getItem(EDIT_TOKEN_STORAGE_KEYS.role) ===
    EDIT_TOKEN_ROLE.DESIGNER &&
  Boolean(sessionStorage.getItem(EDIT_TOKEN_STORAGE_KEYS.token))

/**
 * Whether this tab's session was opened through a QC edit URL (the order's
 * shared QC-role token). QC gets the full messenger-level editor but a
 * review-shaped shell: the storefront step navigation (products / theme
 * selection) stays hidden so a reviewer can't restage the order.
 */
export const isQcTokenSession = (): boolean =>
  sessionStorage.getItem(EDIT_TOKEN_STORAGE_KEYS.role) === EDIT_TOKEN_ROLE.QC
